export async function parseCSV(csvFile: File) {
  const fileContent = await csvFile.text();
  const rows = fileContent.split('\n').filter((row) => row.trim() !== '');
    if (rows.length === 0) {
      return [];
    }
    const headers = rows
      .splice(0, 1)[0]
      .split(',')
      .map((h) => h.trim());
    return rows.map((row) => {
      const cells = splitCells(row);
      const obj = {} as any;
      cells.forEach((col, ind) => {
        obj[headers[ind]] = col.trim();
      });
      return obj;
    });
}

function splitCells(rowString: string) {
  let quoteOpen = false;
  let lastDelimiter = -1;
  const row = [];
  for (let ind = 0; ind < rowString.length; ind++) {
    const currentChar = rowString[ind];

    if (currentChar === ',' && !quoteOpen) {
      row.push(rowString.slice(lastDelimiter + 1, ind));
      lastDelimiter = ind;
    } else if (currentChar === '"') {
      quoteOpen = !quoteOpen;
    }
  }
  function removeQuotes(cell: string) {
    let newCell = cell;
    if (newCell[0] === '"' && newCell[newCell.length - 1] === '"') {
      newCell = newCell.slice(1, -1);
    }
    for (let i = 0; i < newCell.length; i++) {
      const currentChar = newCell[i];
      if (currentChar === '"') {
        newCell = newCell.slice(0, i) + newCell.slice(i + 1);
      }
    }
    return newCell;
  }
  row.push(rowString.slice(lastDelimiter + 1));
  return row.map((cell) => removeQuotes(cell));
}

export async function parseXML(xmlFile: File) {
  const fileContent = await xmlFile.text();
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(fileContent, 'application/xml');
  const xmlToJson = (node: any): any => {
    if (node.nodeType === 3) {
      return node.nodeValue;
    }
    let obj: any = {};
    if (node.attributes && node.attributes.length > 0) {
      for (let i = 0; i < node.attributes.length; i++) {
        const attr = node.attributes.item(i);
        if (attr) obj[`@${attr.nodeName}`] = attr.nodeValue;
      }
    }
    if (node.childNodes && node.childNodes.length > 0) {
      for (let i = 0; i < node.childNodes.length; i++) {
        const child = node.childNodes.item(i);
        if (!child) continue;
        const childName = child.nodeName;
        const childJson = xmlToJson(child);
        if (child.nodeType === 3 && child.nodeValue.trim() === '') continue;
        if (obj[childName]) {
          if (!Array.isArray(obj[childName])) {
            obj[childName] = [obj[childName]];
          }
          obj[childName].push(childJson);
        } else if (child.nodeType !== 3 || child.nodeValue.trim() !== '') {
          obj[childName] = childJson;
        }
      }
    }
    return obj;
  };
  return xmlToJson(xmlDoc.documentElement);
}
